import $ from 'jquery'
import MainHeading from '@/components/MainHeading'

export default {
  name: 'Contact',
  components: {
    MainHeading
  },
  data() {
    return {
      notification: 'Please provide information below and I will respond as soon as possible',
      formStatus: ''
    }
  },
  methods: {
    formSubmit(e) {
      e.preventDefault()

      this.formStatus = ''
      this.notification = 'Please provide information below and I will respond as soon as possible'

      let fname = $("#fname").val()
      let lname = $("#lname").val()
      let email = $("#email").val()
      let message = $("#message").val()
      // Checking for blank fields.
      if (fname == '' || lname == '' || email == '' || message == '') {
        // alert("Please Fill Required Fields")
        this.formStatus = 'notification-error'
        this.notification = 'Oh no! There was a problem submitting your form. Please try again...'
      } else {
        // Returns successful data submission message when the entered information is stored in database.
        $.post("../../php/contact.php", {
          fname1: fname,
          lname1: lname,
          email1: email,
          message1: message,
        }, (res) => {
          this.notification = res // Append returned message to message paragraph.
          if (res === "Thank you for contacting me. Your message has been received!") {
            this.notification = 'Thank you for contacting me. Your message has been received!'
            this.formStatus = 'notification-success'
            $("form")[0].reset() // To reset form fields on success.
          } else {
            this.formStatus = 'notification-error'
          }
        })
      }
    },
    mounted() {
      this.formStatus = ''
    }
  },
}